import {redColor, nightOrangeColor, orangeColor, yellowColor, greenColor, blueColor, DodgerBlueColor, purpleColor, brownColor, grayColor} from '../styles/jss/cmsMainStyle'

const avatarNameColor = name => {
	let color = ""

	switch(name) {
		case "A":
			color = redColor[4]
			  break
		case "B":
			color = nightOrangeColor[4]
			break
		case "C":
			color = orangeColor[4]
			break
		case "D":
			color = yellowColor[4]
			break
		case "E":
			color = greenColor[4]
			break
		case "F":
			color = blueColor[4]
			break
		case "G":
			color = DodgerBlueColor[4]
			break
		case "H":
			color = purpleColor[4]
			break
		case "I":
			color = brownColor[4]
			break
		case "J":
			color = redColor[5]
			break
		case "K":
			color = nightOrangeColor[5]
			break
		case "L":
			color = orangeColor[5]
			break
		case "M":
			color = yellowColor[5]
			break
		case "N":
			color = greenColor[5]
			break
		case "O":
			color = blueColor[5]
			break
		case "P":
			color = DodgerBlueColor[5]
			break
		case "Q":
			color = purpleColor[5]
			break
		case "R":
			color = brownColor[5]
			break				
		case "S":
			color = redColor[6]
			break
		case "T":
			color = nightOrangeColor[6]
			break
		case "U":
			color = orangeColor[6]
			break
		case "V":
			color = yellowColor[6]
			break
		case "W":
			color = greenColor[6]
			break
		case "X":
			color = blueColor[6]
			break
		case "Y":
			color = DodgerBlueColor[6]
			break
		case "Z":
			color = purpleColor[6]
			break
		default:
			color = grayColor[5]
	}

	return color
}


const avatarTypeColor = type => {
	let color = ""

	switch(type) {
		case "USER":
			color = orangeColor[4]
			  break
		case "USERGROUP":
			color = greenColor[4]
			break
		case "EMAIL":
			color = brownColor[4]
			break
		default:
			color = grayColor[4]
	}

	return color
}


export {avatarNameColor, avatarTypeColor}